module.exports = __webpack_public_path__ + "img/user inactive.c0fc7d07.svg";